import { getPreferences } from '../../containers/User/sagas';
import { doctorsPreferencesCollectionRef } from '../../firebase/collection/collectionReferences';

export default class GetDoctorsFavoritesUseCase {
  static *get(successCallback, failureCallback) {
    yield* getPreferences(doctorsPreferencesCollectionRef, successCallback, failureCallback);
  }
}
